import { FolioNumber } from "../types";

export const NEW_FOLIO_VALUE = "New Folio";

export const isNewFolio = (value: number | string | null) => {
  if (!value) return true;
  return value === NEW_FOLIO_VALUE;
};

export function getFolioOptions(folioNumbers: FolioNumber[]) {
  return [
    {
      label: "New Folio",
      value: NEW_FOLIO_VALUE,
      internal_flag: null,
    },
    ...folioNumbers.map((folio) => ({
      label: folio.folio_number,
      value: folio.id.toString(),
      internal_flag: folio.internal_flag,
    })),
  ];
}
